import { Button, FormLayout } from 'components/common'
import MultiSelectStoreDropdown from 'components/common/multiSelectStoreDropdown'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { triggerAggregatorApi, triggerFtp } from 'utils/api/aggregatorApi'
import { handleError } from 'utils/helpers/handleError'

type Props = {
  aggregator?: any
}
const AggregatorApiFtpGeneration = ({ aggregator }: Props) => {
  const {
    formState: { errors },
    setValue,
    handleSubmit,
  } = useForm()

  const handleAggregatorApi = async (data: any) => {
    if (!data.storeIds || data.storeIds.length === 0) {
      toast.error('Please select at least one store from dropdown')
      return
    }
    const loadingToast = toast.loading('Loading..')

    try {
      await triggerAggregatorApi(aggregator.aggregatorId, data)
      toast.success('Aggregator API Job Initiated', {
        id: loadingToast,
        duration: 3000,
      })
    } catch (error) {
      handleError(error, loadingToast)
    }
  }

  const handleAggregatorFtp = async (data: any) => {
    if (!data.storeIds || data.storeIds.length === 0) {
      toast.error('Please select at least one store from dropdown')
      return
    }
    const loadingToast = toast.loading('Loading..')

    try {
      await triggerFtp(aggregator.aggregatorId, data)
      toast.success('FTP Creation Job Initiated', {
        id: loadingToast,
        duration: 3000,
      })
    } catch (error) {
      handleError(error, loadingToast)
    }
  }

  return (
    <>
      <div className="mb-1  gap-5">
        <h3 className="title"> Aggregator Level FTP and Aggregator API</h3>
      </div>
      <FormLayout>
        <form>
          <div className="flex flex-col gap-2">
            <div className="max-w-xs gap-3">
              <MultiSelectStoreDropdown
                resetForm
                setValue={setValue}
                label={'Available Stores'}
                name={'storeIds'}
                error={errors?.storeIds?.message as string}
              />
            </div>

            <div className="flex gap-3">
              <Button
                type="button"
                onClick={handleSubmit(handleAggregatorApi)}
                className="flex-1/2"
                buttonText="Trigger Aggregator API"
              />
              <Button
                type="button"
                onClick={handleSubmit(handleAggregatorFtp)}
                className="flex-1/2"
                buttonText="Trigger FTP"
              />
            </div>
          </div>
        </form>
      </FormLayout>
    </>
  )
}

export default AggregatorApiFtpGeneration
